<template>
	<div class="components">
		<el-select size="mini" clearable v-model="curId"
		:disabled = "disabled"
		@change="changeActivity"
		placeholder="请选择">
			<el-option v-for="item in list" :key="item._id" :label="item.name" :value="item._id"></el-option>
		</el-select>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				curId:'',
				oldId:'',
				oldName:'',
				list:[]
			}
		},
		props:{
			userInfo:{
				default:''
			},
			row:{
				default:{}
			},
			disabled:{
				default:false
			}
		},
		mounted(){
			if(this.$public.isNull(this.row.activityId)){
				this.curId = ''
				this.oldId = ''
				this.oldName = ''
			}else{
				this.curId = this.row.activityId
				this.oldId = this.row.activityId
				this.oldName = this.row.activityName
			}
			if(this.$public.isNull(this.row.activityList)){
				this.getActivityList();
			}else{
				this.list = this.row.activityList;
			}
		},
		methods:{
			// 改变参与的活动
			changeActivity() {
				let item;
				if(this.$public.isNull(this.curId)){
					item = {}
				}else{
					for(let i=0;i<this.list.length;i++){
						if(this.curId===this.list[i]._id){
							item = this.list[i]
						}
					}
				}
				this.$emit("change",{
					activityList:this.list,
					curActivity:item,
					
					curIndex:this.row.index,
					oldId:this.oldId,
					oldName:this.oldName,
				})
			},
			// 获取活动列表
			getActivityList(){
				this.$util.getActivityOfProduct(this.userInfo,[this.row]).then(res=>{
					this.list = res[0].list;
					let item = {}
					if(!this.$public.isNull(this.list)&&this.list[0].auto_matching>0){
						item = this.list[0];
					}
					this.$nextTick(()=>{
						this.$emit("change",{
							activityList:this.list,
							curActivity:item,
							
							curIndex:this.row.index,
							oldId:this.oldId,
							oldName:this.oldName,
						})
					})
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	.components{
		
	}
</style>
